import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import {
  languageOptions,
  useTranslation,
} from "@/hooks/useTranslation/useTranslation"
import { IconWorld } from "@tabler/icons-react"
import { ChevronsUpDown } from "lucide-react"
import { SidebarFooterOption } from "./layout/SidebarFooterOption"

export function LanguageSelector() {
  const { translate, changeLanguage, currentLanguageName } = useTranslation()

  const dropDownlanguageOptions = languageOptions.map((i) => ({
    name: i.name,
    value: i.key,
  }))

  const { isMobile } = useSidebar()

  const handleLanguageChange = (value: string) => {
    changeLanguage(value)
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger className="w-full">
            <SidebarFooterOption
              title={translate("SIDEBAR/LANGUAGE")}
              description={currentLanguageName}
              icon={IconWorld}
              rightElement={<ChevronsUpDown className="ml-auto size-4" />}
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">
                    {translate("SIDEBAR/CHOOSE_LANGUAGE")}
                  </span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              {dropDownlanguageOptions.map((item) => {
                return (
                  <DropdownMenuItem
                    key={item.value}
                    onClick={() => handleLanguageChange(item.value)}
                  >
                    {item.name}
                  </DropdownMenuItem>
                )
              })}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
